module.exports = __webpack_public_path__ + "assets/img/RSPCA-Pet-Insurance-Pillar-Page-Resource.77a48b1f.jpg";